import { configureStore } from "@reduxjs/toolkit";
import webRegisterCartReducer from "../features/WebRegister/cartSlice";
import categoriesReducer from "../features/Categories/categoriesSlice";
import attributesReducer from "../features/Attributes/attributesSlice";
import AskAIReducer from "../features/AskAI/AskAI";
import chatbotReducer from "../features/Chatbot/chatbotSlice";
import addEmployeeReducer from "../features/StoreSettings/AddEmployee/AddEmployeeSlice";
import inStoreOrderReducer from "../features/OrdersNewUI/inStoreOrderSlice";
import onlineStoreOrderReducer from "../features/OrdersNewUI/onlineStoreOrderSlice";
import settingstoreoptionReducer from "../features/StoreSettingOption/StoreSettingOptionSlice";
import systemAccessListingReducer from "../features/SystemAccess/systemAccessSlice";
import couponListReducer from "../features/Coupon/couponSlice";
import inventoryListingReducer from "../features/Inventory/InventorySlice";
import taxesReducer from "../features/Taxes/taxesSlice";
import CurrentInventoryReducer from "../features/CurrentInventoryValue/currentInventoryValueSlice";
import settingstorealtersReducer from "../features/SettingStoreAlters/SettingStoreAltersSlice";
import SettingReceiptReducer from "../features/StoreSettings/SettingsReceipt/SettingsReceiptSlice";
import PurchaseOrderListingUiReducer from "../features/PurchaseOrderListing/purchaseOrderListingUiSlice";
import CheckIDVerifyListReducer from "../features/Reports/CheckIDVerify/CheckIDVerifySlice";
import DailyReportList from "../features/DailyReport/dailyreportSlice";
import NewCustomerReportList from "../features/NewCutomerReport/newCustomerReportSlice";
import EmployeeListReducer from "../features/EmployeeList/EmployeeListSlice";

import PaymentMethodDetailReducer from "../features/PaymentMethodReport/PaymentMethodSlice";

import TopsallerReducer from "../features/TopSaller/topsallerSlice";
import TopsallerOldReducer from "../features/TopSaller/topsallerOldSlice";
import instantactivitySlice from "../features/InstantActivity/instantactivitySlice";

import RegisterSettingReducer from "../features/StoreSettings/RegisterSettings/RegisterSettingsSlice";

import NewItemCreatedBtnListReducer from "../features/Reports/NewItemCreatedBetweenSlice/NewItemCreatedBetweenSlice";
import ExportInventoryReducer from "../features/ExportInventory/ExportInventorySlice";
import StoreOrderSliceReducer from "../features/StoreOrder/StoreOrderSlice";
import ItemSalesReportListReducer from "../features/Reports/ItemSales/ItemSalesSlice";
import NewItemSalesReportListReducer from "../features/Reports/NewItemSales/NewItemSalesSlice";
import DailySalesTotalsReducer from "../features/Reports/DailySalesTotals/DailySalesTotalsSlice";
import CategorySalesReportReducer from "../features/Reports/CategorySalesReport/CategorySalesReportSlice";
import HourlySalesReportReducer from "../features/Reports/HourlySalesReport/HourlySalesReportSlice";
import SalesItemNewReducer from "../features/Reports/SalesItemNew/SalesItemNewSlice";
import OrderTypeReducer from "../features/OrderType/OrderTypeSlice";
import TaxesreportSliceReducer from "../features/TaxesReport/taxesreportSlice";
import PermissionListReducer from "../features/Permission/PermissionSlice";
import PermissionPresetListReducer from "../features/PermissionPreset/PermissionPresetSlice";
import permissionsSlice from "../features/Authentication/permissionsSlice";
import ReorderInventoryListReducer from "../features/Reports/ReorderInventory/ReorderInventorySlice";
import DefaultsSliceReducer from "../features/Defaults/defaultsSlice";
import SalesByPersonSliceReducer from "../features/SalesByPerson/SalesByPersonSlice";
import CustomerSliceReducer from "../features/user/customerSlice";
import ManagerSliceReducer from "../features/user/managerSlice";
import AdminSliceReducer from "../features/user/adminSlice";
import VerifiedMerchantSliceReducer from "../features/user/verifiedMerchantSlice";
import SuperadminSliceReducer from "../features/user/superadminSlice";
import UnVerifiedMerchantSliceReducer from "../features/user/unverifiedMerchantSlice";
import VendorListReducer from "../features/Reports/VendorList/VendorListSlice";
import VendorSalesListReducer from "../features/Reports/VendorSales/VendorSalesSlice";
import OrderRefundListReducer from "../features/Reports/OrderRefundReport/OrderRefundReportSlice";
import NewsLetterListReducer from "../../Redux/features/NewsLetter/NewsLetterSlice";
import vendorReducer from "../features/VendorList/vListSlice";
import newVendorListReducer from "../features/VendorList/newvendorListSlice";
import orderSummerySlice from "../features/OrderSummary/OrderSummarySlice";

import productsReducer from "../features/Product/ProductSlice";

import loyaltyprogramSlice from "../features/LoyaltyProgram/loyaltyprogramSlice";
import SettingSetupSlice from "../features/SettingSetup/SettingSetupSlice";
import ShiftSummarySlice from "../features/Reports/ShiftSummary/ShiftSummarySlice";
import DetailCategorySaleSliceReducer from "../features/DetailCategorySale/detailCategorySaleSlice";
import DetailCategorySaleOldSliceReducer from "../features/DetailCategorySale/detailCategorySaleOldSlice";
import EmployeeWorkinghrsSlice from "../features/Reports/EmployeeWorkinghrs/EmployeeWorkinghrsSlice";
import MenuSlice from "../features/NavBar/MenuSlice";
import LoginSliceReducer from "../features/Authentication/loginSlice";
import orderSummeryReducer from "../features/orderSummeryHistory/orderSummerySlice";
import SalesReportSlice from "../features/Reports/SalesReport/SalesReportSlice";
import TipReportSlice from "../features/Reports/TipReport/TipReportSlice";
import CouponReportSlice from "../features/Reports/CouponReport/CouponReportSlice";
import PaymentReportFactSlice from "../features/Reports/PaymentReport/PaymentReportFactSlice";
import CouponReportFactSlice from "../features/Reports/CouponReport/CouponReportFactSlice";
import TimesheetSlice from "../features/Timesheet/timesheetSlice";
import RefundReportSlice from "../features/Reports/RefundReport/RefundReportSlice";
import RefundLogsReportSlice from "../features/Reports/RefundLogsReport/RefundLogsReportSlice";
import StocktakeListSlice from "../features/Stocktake/StocktakeListSlice";
import SupportDetailsSlice from "../features/SupportDetails/supportDetailsSlice";
import DigitalMarketingSlice from "../features/DigitalMarketing/digitalMarketingSlice";
import BrandsSlice from "../features/Brand/brandsSlice";
import brandTagListReducer from "../features/Brand/brandTagListSlice";
import PayInReportSlice from "../features/Reports/PayInReport/PayInReportSlice";
import DropCashReportSlice from "../features/Reports/DropCashReport/DropCashReportSlice";
import CategorySalesReportSlice from "../features/CategorySalesSummeryReport/categorySalesSummeryReportSlice";
import SalesByHoursReportSlice from "../features/Reports/SalesByHours/SalesByHoursSlice";
import StoreCreditReportSlice from "../features/Reports/StoreCreditReport/StoreCreditReportSlice";
import EmployeeSalesPerCategorySlice from "../features/Reports/EmployeeSalesPerCategory/EmployeeSalesPerCategorySlice";
import DetailedLoyaltyPointsReportSlice from "../features/Reports/DatailedLoyaltyPointsReport/DetailedLoyaltyPointsReportSlice";
import GiftCardReportSlice from "../features/Reports/GiftCard/GiftCardReportSlice";
import RefundRequestSlice from "../features/RefundRequest/RefundRequestSlice";
import NewCustomersAddedReportSlice from "../features/Reports/NewCustomersAddedReport/NewCustomersAddedReportSlice";
import MixAndMatchSliceReducer from "../features/MixAndMatch/mixAndMatchSlice";
import RegisterClosuresSlice from "../features/Reports/RegisterClosures/RegisterClosuresSlice";
import loyaltyprogramStoreSliceReducer from "../features/LoyaltyProgramStore/loyaltyProgramStoreSlice";
import RevenueChartSlice from "../features/Dashboard/Charts/RevenueChartSlice";
import customerCountSlice from "../features/Dashboard/Charts/customerCountSlice";
import salesCountChartSlice from "../features/Dashboard/Charts/salesCountSlice";
import topSalesPersonSlice from "../features/Dashboard/Tables/topSalesPersonSlice";
import grossProfitChartSlice from "../features/Dashboard/Charts/grossProfitChartSlice";
import discountChartSlice from "../features/Dashboard/Charts/discountChartSlice";
import percentageDiscountChartSlice from "../features/Dashboard/Charts/percentageDiscountChartSlice";
import avgItemSaleChartSlice from "../features/Dashboard/Charts/avgItemSaleChartSlice";
import avgSaleValueChartSlice from "../features/Dashboard/Charts/avgSaleValueChartSlice";
import consolidatedDashboardReducer from "../features/Dashboard/consolidatedDashboardSlice";
import discountSalesReportSlice from "../features/Reports/DiscountSalesReport/discountSalesReportSlice";
import discountSalesReportOldSlice from "../features/Reports/DiscountSalesReport/discountSalesReportOldSlice";
import vendorSalesReportSlice from "../features/Reports/VendorSales/vendorSalesReportSlice";
import singleStoresReducer from "../features/SingleStore/singleStoresSlice";
import customerSlice from "../features/Customer/customerSlice";
import customerTotalSlice from "../features/Customer/customerTotalSlice";
import OldSalesReportSlice from "../features/OldSalesSummerySlice/OldSalesSummerySlice";
import Bogo from "../features/BogoListing/bogoListingSlice";
import ConfigureCategoriesReducer from "../features/ConfigureCategories/configureCategoriesSlice";
import QuickveeCustomSlice from "../features/QuickveeCustom/QuickveeCustomSlice";
import qcListSlice from "../features/QCList/qcListSlice";

import ordercouponListReducer from "../features/Coupon/ordercouponSlice";
import itemcouponListReducer from "../features/Coupon/itemcouponSlice";
import EmployeeRatingsReportSlice from "../features/Reports/EmployeeRatingsReport/EmployeeRatingsReportSlice";
import uberReportsSlice from "../features/UberReports/uberReportsSlice";
import merchantFeedSlice from "../features/MerchantFeed/merchantFeedSlice";
import uberBillingSlice from "../features/UberReports/uberBillingSlice";
import telnyxMassSmsReducer from "../features/TelnyxMassSMS/telnyxMassSmsSlice";
import restrictedKeywordsReducer from "../features/RestrictedKeywords/restrictedKeywordsSlice";

// import recentActivitySlice from "./features/Dashboard/Charts/recentActivitySlice"; // Path check
import recentActivityReducer from "../features/Dashboard/Charts/recentActivitySlice";

import featureAnnouncementReducer from "../features/FeatureAnnouncement/FeatureAnnouncementSlice";
import bulkProductUpdateReducer from "../features/BulkProductUpdate/BulkProductUpdateSlice";
import bulkStoreSettingsReducer from "../features/BulkStoreSettings/BulkStoreSettingsSlice";
import transferCatalogReducer from "../features/InventoryTransfer/transferCatalogSlice";

const store = configureStore({
  reducer: {
    VendorList: VendorListReducer,
    vendors: vendorReducer,
    newVendorList: newVendorListReducer,
    categories: categoriesReducer,
    attributes: attributesReducer,
    askAI: AskAIReducer,
    chatbot: chatbotReducer,
    purchaseOrderListingUi: PurchaseOrderListingUiReducer,
    stocktakeList: StocktakeListSlice,
    qclist: qcListSlice,
    inStoreOrder: inStoreOrderReducer,
    onlineStoreOrder: onlineStoreOrderReducer,
    employeelistData: addEmployeeReducer,
    couponList: couponListReducer,
    ordercouponList: ordercouponListReducer,
    itemcouponList: itemcouponListReducer,
    settingStoreOption: settingstoreoptionReducer,
    taxes: taxesReducer,
    systemAccessList: systemAccessListingReducer,
    inventoryDataList: inventoryListingReducer,
    settingstoreoption: settingstoreoptionReducer,
    settingstorealters: settingstorealtersReducer,
    SettingReceiptList: SettingReceiptReducer,
    CheckIDVerifyList: CheckIDVerifyListReducer,
    dailyreport: DailyReportList,
    detailCategorySale: DetailCategorySaleSliceReducer,
    // PHP-backed twin: the "Category Sales (Detailed - Old)" screen behind
    // ?source=old. The fact-table one above is the default.
    detailCategorySaleOld: DetailCategorySaleOldSliceReducer,
    permissions: permissionsSlice,
    permissionPreset: PermissionPresetListReducer,
    // Dashboard Charts slices
    consolidatedDashboard: consolidatedDashboardReducer,
    revenueChart: RevenueChartSlice,
    recentActivity: recentActivityReducer, // Added here
    salesCountChart: salesCountChartSlice,
    customerCountChart: customerCountSlice,
    grossProfitChart: grossProfitChartSlice,
    discountChart: discountChartSlice,
    percentageDiscountChart: percentageDiscountChartSlice,
    avgItemSaleChart: avgItemSaleChartSlice,
    avgSaleValueChart: avgSaleValueChartSlice,
    newCustomerreport: NewCustomerReportList,
    topSalesPerson: topSalesPersonSlice,

    //reducer for payment method  report
    paymentDetailReport: PaymentMethodDetailReducer,

    NewItemCreatedBtnList: NewItemCreatedBtnListReducer,
    ReorderInventoryList: ReorderInventoryListReducer,

    topsaller: TopsallerReducer,
    // Legacy PHP-backed twin, powering "Top-Selling Products (Old)".
    topsallerOld: TopsallerOldReducer,
    instantactivity: instantactivitySlice,

    RegisterSettingsData: RegisterSettingReducer,

    NewsLetterList: NewsLetterListReducer,

    //Employee List Data
    employeeDataList: EmployeeListReducer,
    ExportInventoryData: ExportInventoryReducer,

    ItemSalesReportList: ItemSalesReportListReducer,
    NewItemSalesReportList: NewItemSalesReportListReducer,
    dailySalesTotals: DailySalesTotalsReducer,
    categorySalesReport: CategorySalesReportReducer,
    hourlySalesReport: HourlySalesReportReducer,
    salesItemNew: SalesItemNewReducer,

    // Discount Sales report
    discountSalesReport: discountSalesReportSlice,
    // PHP-backed twin. For this report it is the DEFAULT "Discounts Report"
    // screen; the fact-table one above is behind ?source=new.
    discountSalesReportOld: discountSalesReportOldSlice,

    // Vendors Sales report
    vendorSalesReport: vendorSalesReportSlice,

    //Order Type
    orderTypeList: OrderTypeReducer,

    taxesreport: TaxesreportSliceReducer,
    currentInventoryreport: CurrentInventoryReducer,
    VendorSalesList: VendorSalesListReducer,

    //Permission

    permissionRed: PermissionListReducer,

    StoreOrderList: StoreOrderSliceReducer,

    defaults: DefaultsSliceReducer,

    SalesByPersonList: SalesByPersonSliceReducer,

    customerRecord: CustomerSliceReducer,
    managerRecord: ManagerSliceReducer,
    adminRecord: AdminSliceReducer,
    verifiedMerchantRecord: VerifiedMerchantSliceReducer,
    superadminList: SuperadminSliceReducer,
    unverifiedMerchantRecord: UnVerifiedMerchantSliceReducer,
    OrderRefundList: OrderRefundListReducer,
    productsListData: productsReducer,
    mixAndMatchList: MixAndMatchSliceReducer,
    loyaltyprogram: loyaltyprogramSlice,
    ShiftSummarylist: ShiftSummarySlice,
    StoreSetupList: SettingSetupSlice,
    EmpWorkinghrsList: EmployeeWorkinghrsSlice,
    loginAuthentication: LoginSliceReducer,
    orderSummeryList: orderSummeryReducer,

    NavBarToggle: MenuSlice,
    timeSheet: TimesheetSlice,
    SalesReportList: SalesReportSlice,
    TipReportList: TipReportSlice,
    CouponReportList: CouponReportSlice,
    PaymentReportFact: PaymentReportFactSlice,
    CouponReportFact: CouponReportFactSlice,
    RefundDataList: RefundReportSlice,
    RefundLogsReportList: RefundLogsReportSlice,
    PayinReportList: PayInReportSlice,
    DropCashReportList: DropCashReportSlice,
    GiftCardReportList: GiftCardReportSlice,
    EmployeeSalesPerCategoryList: EmployeeSalesPerCategorySlice,
    supportDetail: SupportDetailsSlice,
    digitalmarketing: DigitalMarketingSlice,
    brandData: BrandsSlice,
    brandTagList: brandTagListReducer,
    categorySalesReportData: CategorySalesReportSlice,
    SalesByHoursData: SalesByHoursReportSlice,
    storeCreditReportList: StoreCreditReportSlice,
    DetailedLoyaltyPointsReport: DetailedLoyaltyPointsReportSlice,
    RefundRequestList: RefundRequestSlice,
    NewCustomersAddedReport: NewCustomersAddedReportSlice,
    RegisterClosuresReport: RegisterClosuresSlice,
    LoyaltyProgramStoreData: loyaltyprogramStoreSliceReducer,
    NewCustomerList: customerSlice,
    customerTotal: customerTotalSlice,

    singleStores: singleStoresReducer,
    OldSalseSummery: OldSalesReportSlice,
    bogo: Bogo,
    ConfigureCategories: ConfigureCategoriesReducer,
    QuickveeCustomList: QuickveeCustomSlice,
    EmployeeRatingsReportList: EmployeeRatingsReportSlice,

    uberReports: uberReportsSlice,
    merchantFeed: merchantFeedSlice,
    uberBilling: uberBillingSlice,
    telnyxMassSms: telnyxMassSmsReducer,
    restrictedKeywords: restrictedKeywordsReducer,

    featureAnnouncement: featureAnnouncementReducer,
    bulkProductUpdate: bulkProductUpdateReducer,
    bulkStoreSettings: bulkStoreSettingsReducer,
    transferCatalog: transferCatalogReducer,

    webRegisterCart: webRegisterCartReducer,
  },

  //setting setup

  //ShiftSummarySlice

  // middleware:(getDefaultMiddleware)=> getDefaultMiddleware().concat(logger),
});

export default store;
